import React, { useState, useEffect, useRef } from "react";
import { Toast } from "primereact/toast";
import { RadioButton } from "primereact/radiobutton";
import { Dropdown } from "primereact/dropdown";

import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Button } from "primereact/button";
import { Rating } from "primereact/rating";
import { Tag } from "primereact/tag";
import { ProgressSpinner } from "primereact/progressspinner";
import { API_CREATE_NOTIFICATION } from "../../api/notification.service";
import {
  API_ALL_COMPANIES,
  API_ADD_COMPANY,
  API_INITIATE_ONBOARDING,
  API_ADD_SUBSCRIPTION,
  API_CHECK_FB_STATUS,
  API_ADD_NEW_COMPANY,
} from "../../api/company.service";
import { Link } from "react-router-dom";
import { Panel } from "primereact/panel";
import { InputSwitch } from "primereact/inputswitch";
import { InputText } from "primereact/inputtext";
import { Dialog } from "primereact/dialog";
import { GenerateBill } from "./generateBill";
import "./companies.css";

export const Companies = () => {
  const [companies, setCompanies] = useState([]);
  const [selectedCompanies, setSelectedCompanies] = useState([]);
  const [search, setSearch] = useState("");
  const [visibleBill, setVisibleBill] = useState(false);
  const [visibleAddCompany, setVisibleAddCompany] = useState(false);
  const [loading, setLoading] = useState(false);
  const [visibleNotification, setVisibleNotification] = useState(false);
  const [notification, setNotification] = useState({
    companyId: selectedCompanies,
    isEnabled: true,
    message: "",
    type: null,
  });

  const toast = useRef(null);

  const notificationTypes = [
    { label: "Info", value: "info" },
    { label: "Warn", value: "warning" },
    { label: "Error", value: "error" },
    { label: "Success", value: "success" },
    { label: "Secondary", value: "secondary" },
    { label: "Contrast", value: "contrast" },
  ];
  const handleAddNotification = async () => {
    if (!notification.message || !notification.type) {
      toast.current.show({
        severity: "warn",
        summary: "Missing Fields",
        detail: "Please fill all fields before saving.",
        life: 3000,
      });
      return;
    }

    setLoading(true);
    try {
      const payload = selectedCompanies.map((company) => ({
        companyId: company.id,
        type: notification.type,
        message: notification.message,
        isEnabled: notification.isEnabled,
      }));

      const response = await API_CREATE_NOTIFICATION(payload);

      toast.current.show({
        severity: "success",
        summary: "Notification Created",
        detail: "Your notification was successfully added!",
        life: 3000,
      });
      setVisibleNotification(false);
    } catch (error) {
      console.error("Error creating notification:", error);

      toast.current.show({
        severity: "error",
        summary: "Error",
        detail: "Failed to create notification. Try again.",
        life: 3000,
      });
    }
    setLoading(false);
  };

  const notificationDialog = () => (
    <Dialog
      header="Add Notification"
      visible={visibleNotification}
      style={{ width: "40vw" }}
      onHide={() => setVisibleNotification(false)}
    >
      <div className="p-fluid">
        {/* Is Enabled Radio Button */}
        <div className="p-field">
          <label>Enable Notification</label>
          <div className="flex align-items-center gap-3">
            <RadioButton
              inputId="enabled"
              name="isEnabled"
              value={true}
              onChange={() =>
                setNotification({ ...notification, isEnabled: true })
              }
              checked={notification.isEnabled}
            />
            <label htmlFor="enabled">Enabled</label>

            <RadioButton
              inputId="disabled"
              name="isEnabled"
              value={false}
              onChange={() =>
                setNotification({ ...notification, isEnabled: false })
              }
              checked={!notification.isEnabled}
            />
            <label htmlFor="disabled">Disabled</label>
          </div>
        </div>

        {/* Message Input */}
        <div className="p-field">
          <label htmlFor="message">Message</label>
          <InputText
            id="message"
            value={notification.message}
            onChange={(e) =>
              setNotification({ ...notification, message: e.target.value })
            }
          />
        </div>

        {/* Type Dropdown */}
        <div className="p-field">
          <label htmlFor="type">Notification Type</label>
          <Dropdown
            id="type"
            value={notification.type}
            options={notificationTypes}
            onChange={(e) =>
              setNotification({ ...notification, type: e.value })
            }
            placeholder="Select Type"
          />
        </div>
      </div>

      {/* Dialog Footer Buttons */}
      <div className="p-dialog-footer" style={{ marginTop: "10px" }}>
        <Button
          label="Cancel"
          icon="pi pi-times"
          onClick={() => setVisibleNotification(false)}
        />
        <Button
          label="Save"
          icon="pi pi-check"
          onClick={handleAddNotification}
        />
      </div>
    </Dialog>
  );
  const [newCompany, setNewCompany] = useState({
    userName: "",
    password: "",
    personalPhone: "",
    gupshupAppName: "",
    companyName: "",
    isActive: true,
    subscriptiontypeId: 1,
  });

  useEffect(() => {
    fetchCompanies();
  }, []);

  const subscriptionOptions = [
    { label: "Growth", value: 1 },
    { label: "Standard", value: 2 },
    { label: "Pro", value: 3 },
  ];

  const fetchCompanies = async () => {
    setLoading(true);
    try {
      const res = await API_ALL_COMPANIES();
      if (res?.companies?.rows) {
        setCompanies(res.companies.rows);
      }
    } catch (error) {
      console.error("Error fetching companies:", error);
    } finally {
      setLoading(false);
    }
  };

  const getSearchCompanies = () => {
    setSelectedCompanies(null);
    API_ALL_COMPANIES(search).then((res) => {
      setCompanies(res.companies.rows);
    });
  };

  const convertDate = (company) => {
    var createdDate = new Date(company.createdAt);
    return <span>{createdDate.toLocaleString()}</span>;
  };

  const addCompanyDialog = () => (
    <Dialog
      header="Add New Company"
      visible={visibleAddCompany}
      style={{ width: "50vw" }}
      onHide={() => setVisibleAddCompany(false)}
    >
      <div className="p-fluid">
        <div className="p-field">
          <label htmlFor="companyName">Company Name</label>
          <InputText
            id="companyName"
            value={newCompany.companyName}
            onChange={(e) =>
              setNewCompany({ ...newCompany, companyName: e.target.value })
            }
          />
        </div>
        {/* <div className="p-field">
          <label htmlFor="gupshupAppName">App Name</label>
          <InputText
            id="gupshupAppName"
            value={newCompany.gupshupAppName}
            onChange={(e) =>
              setNewCompany({ ...newCompany, gupshupAppName: e.target.value })
            }
          />
        </div> */}
        <div className="p-field">
          <label htmlFor="userName">User Name</label>
          <InputText
            id="userName"
            value={newCompany.userName}
            onChange={(e) =>
              setNewCompany({ ...newCompany, userName: e.target.value })
            }
          />
        </div>
        <div className="p-field">
          <label htmlFor="password">Password</label>
          <InputText
            id="password"
            type="password"
            value={newCompany.password}
            onChange={(e) =>
              setNewCompany({ ...newCompany, password: e.target.value })
            }
          />
        </div>
        <div className="p-field">
          <label htmlFor="personalPhone">Personal Phone</label>
          <InputText
            id="personalPhone"
            value={newCompany.personalPhone}
            onChange={(e) =>
              setNewCompany({ ...newCompany, personalPhone: e.target.value })
            }
          />
        </div>

        {/* <div className="p-field">
          <label htmlFor="subscriptiontypeId">Subscription Type</label>
          <Dropdown
            id="subscriptiontypeId"
            value={newCompany.subscriptiontypeId}
            options={subscriptionOptions}
            onChange={(e) =>
              setNewCompany({ ...newCompany, subscriptiontypeId: e.value })
            }
            placeholder="Select Subscription Type"
          />
        </div> */}
      </div>
      <div className="p-dialog-footer" style={{ margin: "10px 0" }}>
        <Button
          label="Cancel"
          icon="pi pi-times"
          onClick={() => setVisibleAddCompany(false)}
        />
        <Button label="Save" icon="pi pi-check" onClick={addNewCompany} />
      </div>
    </Dialog>
  );

  const addCompany = async () => {
    setLoading(true);
    try {
      const onboardResponse = await API_INITIATE_ONBOARDING(newCompany);
      console.log("Onboard API Response:", onboardResponse);
      const companyId = onboardResponse.id;

      if (!companyId)
        throw new Error("Company ID not returned by onboarding API");

      console.log("Extracted Company ID:", companyId);

      const fbStatusResponse = await API_CHECK_FB_STATUS({
        companyId,
        flowName: "igaming-sales-agent",
      });
      console.log("FB Status API Response:", fbStatusResponse);
      if (!fbStatusResponse) throw new Error("Facebook status API call failed");
      const { subscriptiontypeId } = newCompany;
      const subscriptionResponse = await API_ADD_SUBSCRIPTION({
        companyId,
        subscriptiontypeId,
      });
      console.log("Subscription API Response:", subscriptionResponse);
      if (!subscriptionResponse)
        throw new Error("Subscription API call failed");

      setVisibleAddCompany(false);
      setNewCompany({
        userName: "",
        password: "",
        personalPhone: "",
        gupshupAppName: "",
        companyName: "",
        isActive: false,
        subscriptiontypeId: 1,
      });
      fetchCompanies();
      toast.current.show({
        severity: "success",
        summary: "Success",
        detail: "Company added successfully!",
        life: 3000,
      });
    } catch (error) {
      console.error("Error adding company:", error);

      toast.current.show({
        severity: "error",
        summary: "Error",
        detail: `Error: ${error.message}`,
        life: 3000,
      });
    } finally {
      setLoading(false);
    }
  };

  const addNewCompany = async () => {
    setLoading(true);
    try {
      const response = await API_ADD_NEW_COMPANY(newCompany);
      console.log("API Response:", response);

      setVisibleAddCompany(false);
      setNewCompany({
        userName: "",
        password: "",
        personalPhone: "",
        gupshupAppName: "",
        companyName: "",
        isActive: false,
        subscriptiontypeId: 1,
      });
      fetchCompanies();
      toast.current.show({
        severity: "success",
        summary: "Success",
        detail: "Company added successfully!",
        life: 3000,
      });
    } catch (error) {
      console.error("Error adding company:", error);

      toast.current.show({
        severity: "error",
        summary: "Error",
        detail: `Error: ${error.message}`,
        life: 3000,
      });
    } finally {
      setLoading(false);
    }
  };

  const generateBill = () => {
    console.log(selectedCompanies);
    setVisibleBill(true);
  };

  const moreInfoIcon = (company) => {
    return (
      <Link to={"/company/" + company.id}>
        <i
          className="pi pi-info-circle"
          style={{ fontSize: "1rem", cursor: "pointer" }}
        ></i>
      </Link>
    );
  };

  const header = () => {
    return (
      <div
        className="flex"
        style={{
          justifyContent: "space-between",
          alignItems: "center",
          margin: "0px 20px",
        }}
      >
        {/* Left section with Add Company button and search bar */}
        <div style={{ display: "flex", alignItems: "center" }}>
          {/* Add Company button */}
          <Button
            label="Add Company"
            icon="pi pi-plus"
            onClick={() => setVisibleAddCompany(true)}
            style={{
              background: "#30b3d5",
              color: "white",
              marginRight: "15px",
            }}
          />

          {/* Search bar */}
          <InputText
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            placeholder="Search Company"
            style={{ marginRight: "10px" }}
          />
          <span style={{ cursor: "pointer" }} onClick={getSearchCompanies}>
            <i className="pi pi-refresh" style={{ fontSize: "1.3rem" }}></i>
          </span>
        </div>

        {/* Right section for Generate Bill button */}
        {selectedCompanies && selectedCompanies.length > 0 && (
          <div style={{ display: "flex", gap: "10px" }}>
            <Button
              onClick={generateBill}
              style={{ background: "#30b3d5", color: "white" }}
            >
              Generate Usage
            </Button>

            <Button
              onClick={() => setVisibleNotification(true)}
              style={{ background: "#30b3d5", color: "white" }}
            >
              Add Notification
            </Button>
          </div>
        )}
      </div>
    );
  };

  const viewBillPopup = () => {
    var companies = selectedCompanies?.map((cmp) => cmp.id);
    var fileName =
      selectedCompanies.length > 0 ? selectedCompanies[0].companyName : "";
    return (
      <Dialog
        header="Header"
        visible={visibleBill}
        style={{ width: "80vw" }}
        onHide={() => {
          if (!visibleBill) return;
          setVisibleBill(false);
        }}
      >
        <GenerateBill props={{ companies, fileName }} />
      </Dialog>
    );
  };

  return (
    <div className="card">
      <Toast ref={toast} />
      <div className="companies">
        {loading && (
          <div className="loading-container" style={{ textAlign: "center" }}>
            <ProgressSpinner style={{ width: "50px", height: "50px" }} />
          </div>
        )}
        {visibleBill && viewBillPopup()}
        {visibleAddCompany && addCompanyDialog()}
        {visibleNotification && notificationDialog()}

        <Panel>
          <DataTable
            value={companies}
            paginator
            rows={5}
            rowsPerPageOptions={[5, 10, 25, 50]}
            tableStyle={{ minWidth: "50rem" }}
            selection={selectedCompanies}
            onSelectionChange={(e) => setSelectedCompanies(e.value)}
            header={header()}
          >
            <Column
              selectionMode="multiple"
              headerStyle={{ width: "3rem", textAlign: "center" }}
            ></Column>
            <Column field="id" header="Id"></Column>
            <Column field="companyName" header="Name"></Column>
            <Column field="phone" header="Phone"></Column>
            <Column field="gupshupAppName" header="AppName"></Column>
            <Column field="isActive" header="isActive"></Column>
            <Column header="Created Date" body={convertDate}></Column>
            <Column header="More Info" body={moreInfoIcon}></Column>
          </DataTable>
        </Panel>
      </div>
    </div>
  );
};
